import React, { useEffect, useState } from "react";
import { IdleTimerProvider } from "react-idle-timer";
import cookie from "react-cookies";
import Header from "../header/Header";
import ScreenMetrics from "./ScreenMetrics";
import CustomTabs from "../CustomTab";
import {
  Alert,
  Button,
  DialogContent,
  Slide,
  Snackbar,
  Stack,
} from "../../styles/MaterialUI";
import io from 'socket.io-client';
import { getContentUploadProgress, reloadOn } from "../Redux/Features/reloadMetricsSlice";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { removeUserToken } from "../Redux/Features/userTokenSlice";
import { SOCKET_IO_URL, ZOHO_HELP_CENTER_LOGOUT } from "../../constants/apiConstants";
import { hideAlertPopup } from "../Redux/Features/showAlertSlice";
import CustomToasts from "../alerts/CustomToasts";
import { getPortalLinkConfig } from "../../utils/getPortalLinkConfig"
const Dashboard = () => {
  const dispatch = useDispatch();
  const { userToken } = useSelector((state) => state.userToken);
  const { isOpen, severity, message } = useSelector((state) => state.showAlert);
  const { redirectURL, logoutURL, organizationId, primary_product, permitted_products, dashboard_sources, intellidash_flag, intellicast_flag,portal_url, dashboard_url } = useSelector((state) => state.userLogin);
  const [openDialog, setOpenDialog] = useState(false);
  const [idleTimer, setIdleTimer] = useState(null);
  const headers = { Authorization: `Bearer ${userToken}` };



  const portalLink = getPortalLinkConfig({
    primaryProduct: primary_product,
    permittedProducts: permitted_products,
    dashboardSources: dashboard_sources,
    intelliDashFlag : intellidash_flag,
    intelliCastFlag : intellicast_flag,
    portalUrl: portal_url,
    dashboardUrl: dashboard_url
  });

  const handleOnIdle = () => {
    localStorage.setItem('is_cms_session_active', JSON.stringify(false));
    setOpenDialog(true);
    const triggerLogout = setTimeout(() => { handleLogout() }, 300 * 1000);
    return () => clearTimeout(triggerLogout);
  };

  const handleContinue = () => {
    localStorage.setItem('is_cms_session_active', JSON.stringify(true));
    if (idleTimer) {
      idleTimer.reset();
    }
    setOpenDialog(false);
    window.open(redirectURL, "_self");
  };

  const handleLogout = async () => {
    const isPortalActive = JSON.parse(localStorage.getItem('is_portal_session_active'));
    const isCmsActive = JSON.parse(localStorage.getItem('is_cms_session_active'));
    console.log("isPortalActive", isPortalActive, "isCmsActive", isCmsActive);
    if (!isPortalActive && !isCmsActive) {
      cookie.remove('JWTToken');
      dispatch(removeUserToken());
      try {
        localStorage.setItem('is_session_active', false);
        localStorage.setItem('is_portal_session_active', JSON.stringify(false));
        localStorage.setItem('is_cms_session_active', JSON.stringify(false));
        const response = await axios.post(
          `${logoutURL}`,
          { type: "mannual" },
          { headers }
        );

        if (response.status === 200) {
          window.open(response.data, "_self");
          let zohoTabName = localStorage.getItem('zohoHelpObject')
          if (zohoTabName) {
            logoutZohoDesk(zohoTabName);
          }
        } else {
          window.open("https://aristocast.net/", "_self");
        }
      } catch (error) {
        console.error("Error fetching data:", error.message);
      }
    }
  };

  const logoutZohoDesk = (zohoTabName) => {
    window.open(ZOHO_HELP_CENTER_LOGOUT.LOGOUT_URL, zohoTabName);
    localStorage.removeItem("zohoHelpObject");
    return false;
  }

  useEffect(() => {
    localStorage.setItem('is_session_active', true);
    localStorage.setItem('is_cms_session_active', JSON.stringify(true));
    window.addEventListener('storage', e => {
      if (e.key === 'is_session_active') {
        window.open("https://aristocast.net/", "_self")
      }
    });
  }, []);

  const handleRequestData = (organizationId) => {
    const socket = io(SOCKET_IO_URL.API_URL, {
      extraHeaders: {
        organizationid: organizationId,
      },
    });

    socket.on("connect", () => {
      console.log("Connected to server");

      // Emit an event to the server to join the room based on the screen_uiid
      socket.emit("connectCms", { organization_id: organizationId }); //
    });

    socket.on("connectCmsResponse", (data) => { console.log("data1", data); });

    socket.on("cmsStatusChanged", (data) => {
      const { screen_uiid, screen_status, device_screen_status } = data;
      console.log("data2", data);
      dispatch(reloadOn({ screen_uiid, screen_status, device_screen_status }));
    });

    socket.on("uploadProgress", (data) => {
      const { progress, fileName, content_id } = data;
      console.log("uploadProgress", data);
      dispatch(getContentUploadProgress({ progress, fileName, content_id }));
    });

    return () => {
      socket.disconnect();
    };
  };

  useEffect(() => {
    const isPortalActive = JSON.parse(localStorage.getItem('is_portal_session_active'));
    const isCmsActive = JSON.parse(localStorage.getItem('is_cms_session_active'));
    console.log("isPortalActive", isPortalActive, "isCmsActive", isCmsActive);
    // if (isPortalActive && isCmsActive) {
    handleRequestData(organizationId);
    // }
  }, []);

  const closeToast = () => {
    dispatch(hideAlertPopup({ isOpen: false, severity: "", message: "" }));
  }

  return (
    <>
      {userToken !== null ? (
        <>
          <IdleTimerProvider
            ref={(ref) => setIdleTimer(ref)}
            timeout={1800 * 1000}
            onIdle={handleOnIdle}
            debounce={250}
            syncTimers={200}
            crossTab={{
              channelName: "idle-timer",
              emitOnAllTabs: true,
            }}
          />
          {isOpen && <CustomToasts toastInfo={{ isOpen, severity, message }} onClose={closeToast} />}
          {openDialog ? (
            <Snackbar
              open={openDialog}
              onClose={() => setOpenDialog(false)}
              anchorOrigin={{ vertical: "top", horizontal: "center" }}
              TransitionComponent={(props) => (
                <Slide {...props} direction="down" />
              )}
            >
              <DialogContent>
                <Alert variant="standard" severity="warning">
                  You have been idle for 30 mins. Do you want to Continue or
                  Logout?
                </Alert>
                <Stack
                  direction="row"
                  spacing={2}
                  justifyContent="flex-end"
                  style={{
                    backgroundColor: "#fff4e5",
                    marginTop: "-2px",
                    padding: "5px 10px",
                  }}
                >
                  <Button
                    size="small"
                    onClick={handleContinue}
                    sx={{
                      color: "#ff8000",
                      border: "1px solid #ff8000",
                      textTransform: "none",
                      transition: "0.3s ease-in-out",
                      "&:hover": {
                        backgroundColor: "#ff8000",
                        color: "#fff",
                      },
                    }}
                  >
                    Continue
                  </Button>
                  <Button
                    size="small"
                    onClick={handleLogout}
                    sx={{
                      color: "#ff8000",
                      border: "1px solid #ff8000",
                      textTransform: "none",
                      transition: "0.3s ease-in-out",
                      "&:hover": {
                        backgroundColor: "#ff8000",
                        color: "#fff",
                      },
                    }}
                  >
                    Logout
                  </Button>
                </Stack>
              </DialogContent>
            </Snackbar>
          ) : (
            ""
          )}
          <Header portalLink={portalLink} />
          <ScreenMetrics />
          <CustomTabs />
        </>
      ) : (
        ""
      )}
    </>
  );
};

export default Dashboard;
